import { doc, updateDoc } from "firebase/firestore";
import { db } from "../firebase"; 

export const updateData = async (collectionName, docId, data) => {
    try {
        const docRef = doc(db, collectionName, docId);
        await updateDoc(docRef, data);
        return { success: true };
    } catch (error) {
        console.error("Error updating document:", error);
        return { success: false, error: error.message };
    }
};
